/**
 * Applicant gating rule — the single source of truth for whether an authenticated
 * user should be locked into the application wizard / status screen.
 *
 * IMPORTANT: gate ONLY when we definitively know the applicant is not yet
 * approved — the session has been validated server-side AND the status is an
 * explicit `pending`/`rejected`. Never gate on an undefined/stale/loading status:
 * on app load the user is hydrated from a (possibly stale) localStorage cache
 * before `/auth/me` re-validates, so an already-approved contractor would
 * otherwise be flashed into the wizard until validation completes.
 */
export const VERIFIER_APPLICANT_ROLES = ['verifier', 'professional_verifier', 'quality_inspector'];

export function applicantBaseForRole(role) {
  if (role === 'contractor') return '/contractor';
  if (VERIFIER_APPLICANT_ROLES.includes(role)) return '/verifier';
  return null;
}

export function shouldGateApplicant({ isAuthenticated, sessionValidated, role, approvalStatus, isTest }) {
  if (!isAuthenticated || !sessionValidated) return false;   // wait for server validation
  if (!applicantBaseForRole(role)) return false;             // not an applicant role
  if (isTest === true) return false;                         // test accounts bypass
  return approvalStatus === 'pending' || approvalStatus === 'rejected';
}
